__turbopack_context__.v({
  "albyHeading": "AlbyPDP-module-scss-module__LsnjSa__albyHeading",
  "albyQA": "AlbyPDP-module-scss-module__LsnjSa__albyQA",
});
